import { createSlice } from '@reduxjs/toolkit';
import { toString } from 'lodash';
import type { ErrorResponse, LoadersState } from '@sda/interfaces/reducer/loaders.reducer';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: LoadersState = {
  scopes: {},
};

const loadersSlice = createSlice({
  initialState,
  name: 'loaders',
  reducers: {
    setLoaderIsLoading: (state, action: PayloadAction<string>) => {
      state.scopes[action.payload] = {
        name: action.payload,
        status: true,
        loading: true,
      };
    },
    setLoaderIsFinishedSuccess: {
      reducer: (state, action: PayloadAction<{ name: string, data?: unknown }>) => {
        state.scopes[action.payload.name] = {
          name: action.payload.name,
          status: true,
          loading: false,
          data: action.payload.data || null,
        };
      },
      prepare: (scope: string, data?: unknown) => ({
        payload: {
          data,
          name: scope,
        },
      }),
    },
    setLoaderIsFinishedError: {
      reducer: (state, action: PayloadAction<{ name: string, error: ErrorResponse }>) => {
        let text = 'An unexpected error has occurred.';
        const { error: body } = action.payload;

        if (body.error) {
          text = body.error.message;
        } else if (body && body.message) {
          text = body.message;
        } else if (body) {
          text = toString(body);
        }

        state.scopes[action.payload.name] = {
          name: action.payload.name,
          status: false,
          loading: false,
          error: toString(text),
        };
      },
      prepare: (scope: string, error: ErrorResponse) => ({
        payload: {
          error,
          name: scope,
        },
      }),
    },
    deleteLoader: (state, action: PayloadAction<string>) => {
      if (state.scopes[action.payload]) {
        delete state.scopes[action.payload];
      }
    },
  },
});

export const {
  setLoaderIsLoading, setLoaderIsFinishedError, setLoaderIsFinishedSuccess, deleteLoader,
} = loadersSlice.actions;

export default loadersSlice.reducer;
